import { render } from "./TrackingIndex.vue?vue&type=template&id=3299a754"
import script from "./TrackingIndex.vue?vue&type=script&lang=js"
export * from "./TrackingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__